

import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonRow,
  IonCol,
  IonIcon,
  IonItem,
  IonFooter,
  IonCard,
  IonCardContent,
  IonSpinner,
  IonChip,
  IonLabel,
} from '@ionic/vue';
import {
  closeOutline,
  newspaperOutline,
  settingsOutline,
  barbellOutline,
  bookOutline,
  podiumOutline,
  gameControllerOutline,
  schoolOutline,
  libraryOutline,
  arrowForwardOutline,
  calendarOutline,
  exitOutline,
} from 'ionicons/icons';
import {useRouter} from "vue-router";
import {computed, defineComponent, onMounted, ref} from "vue";
import LessonsService from '@/api/lessons/LessonsService';
import MeetingsService from '@/api/meetings/MeetingsService';
// import './home.scss'

export default defineComponent({
  name: "Home.vue",
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonRow,
    IonCol,
    IonIcon,
    IonCard,
    IonCardContent,
    IonSpinner,
    IonChip,
    IonLabel,
    // IonItem,
    // IonFooter,
  },
  created() {
    if (localStorage.getItem('currentClass') == null || localStorage.getItem('currentClass') == undefined) {
      this.$router.push({path: 'selectclass'})
    }
  },
  setup() {
    const router = useRouter();

    const currentUser = ref(JSON.parse(localStorage.getItem('userData') || '{}'))

    const { fetchLessons, getCurrentLessons } = LessonsService();
    const { joinMeeting } = MeetingsService();

    const isJoining = ref(false);

    const lessons = computed(() => {
      const currentLessons = getCurrentLessons() || [];
      return [...currentLessons].sort((firstLesson, secondLesson) => {
        const firstStart = firstLesson && firstLesson.start ? firstLesson.start : 0;
        const secondStart = secondLesson && secondLesson.start ? secondLesson.start : 0;
        return firstStart - secondStart;
      });
    });

    const isMeetingJoinable = meeting => {
      if (!meeting || !meeting.start || !meeting.end) {
        return false;
      }
      const nowMs = Date.now();
      const startMs = meeting.start * 1000;
      const endMs = meeting.end * 1000;
      const windowMs = 15 * 60 * 1000;
      return nowMs >= startMs - windowMs && nowMs <= endMs + windowMs;
    };

    const nextJoinableMeeting = computed(() =>
        lessons.value.find(meeting => isMeetingJoinable(meeting)) || null,
    );

    const formatLessonDay = (timestamp: number) => {
      if (!timestamp) {
        return '';
      }
      const date = new Date(timestamp * 1000);
      return new Intl.DateTimeFormat('it-IT', {
        dateStyle: 'medium',
      }).format(date);
    };

    const formatLessonTime = (timestamp: number) => {
      if (!timestamp) {
        return '';
      }
      const date = new Date(timestamp * 1000);
      return new Intl.DateTimeFormat('it-IT', {
        timeStyle: 'short',
      }).format(date);
    };

    const enterMeeting = async meeting => {
      if (!meeting || !meeting.id || isJoining.value) {
        return;
      }
      isJoining.value = true;
      try {
        const response = await joinMeeting(meeting.id);
        const joinUrl = response
            && response.data
            && response.data.data
            && response.data.data.url
            && response.data.data.url.join_url;
        if (joinUrl) {
          window.open(joinUrl, '_blank');
        }
      } finally {
        isJoining.value = false;
      }
    };

    const homeBackground = computed(() => {
      if (currentUser.value && currentUser.value.company && currentUser.value.company.urls && currentUser.value.company.urls.home_background) {
        return {
          '--background': 'none',
          'background': ' white url(' + currentUser.value.company.urls.home_background + ') no-repeat center',
          'background-size': 'contain'
        }
      }
      return null
    })

    function navigateTo(route) {
      router.push(route)
    }

    onMounted(() => {
      fetchLessons();
    });

    return {
      closeOutline,
      newspaperOutline,
      settingsOutline,
      barbellOutline,
      bookOutline,
      podiumOutline,
      gameControllerOutline,
      schoolOutline,
      libraryOutline,
      arrowForwardOutline,
      calendarOutline,
      exitOutline,

      router,
      currentUser,
      homeBackground,
      navigateTo,
      nextJoinableMeeting,
      formatLessonDay,
      formatLessonTime,
      enterMeeting,
      isJoining,
    }
  },
})
